import React, {useContext} from "react"
import {Drawer, Box, IconButton, Typography, Divider} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import Content from "../Content"
import {DataContext} from "../../../src/context/DataContextProvider"
import { ActionContext } from "../../../src/context/ActionContextProvider"

export const ROOT_DRAWER_POINTER = "/appstate/activeRootDrawerIdentifier"

const RootDrawer = ({drawerContainer = []}) => {
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const {triggerAction, sendDataToBackend} = useContext(ActionContext)
    const activeContainer = getDataFromPointer(ROOT_DRAWER_POINTER)
    const displayContainer = drawerContainer.find(
        (entry) => entry.identifier === activeContainer,
    )
    const anchor = displayContainer?.anchor ?? "right"
    const width = displayContainer?.minWidth ?? 700
    const title = displayContainer?.text
    const subtitle = displayContainer?.subtext
    const isOpen = Boolean(activeContainer)
    const closeDrawer = () => {
        updateData("", ROOT_DRAWER_POINTER)
        displayContainer.closeAction && triggerAction(displayContainer.closeAction)
    }

    return (
        <Drawer
            anchor={anchor}
            open={isOpen}
            onClose={closeDrawer}>
            <Box
                sx={{
                    padding: "40px 24px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    ...(anchor === "top" || anchor === "bottom"
                        ? {width: "auto"}
                        : {
                            width: "100vw",
                            "@media (min-width: 600px)": {width: "75vw"},
                            "@media (min-width: 1000px)": {width: width},
                        }),
                }}
                role="presentation">
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        pb: 2,
                        justifyContent: "space-between",
                    }}>
                    <Box>
                        <Typography
                            variant="h5"
                            component="h5">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography
                                variant="body2"
                                color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                    <IconButton
                        onClick={closeDrawer}
                        edge="end">
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider />

                <Box sx={{pt: 2, flexGrow: 1}}>
                    {displayContainer && <Content child={displayContainer} />}
                </Box>
            </Box>
        </Drawer>
    )
}

export default RootDrawer
